export default __webpack_public_path__ + "static/media/kraken.ccfeff9d.svg";